var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4701 4.47132C12.7305 4.21097 12.7305 3.78886 12.4701 3.52851C12.2098 3.26816 11.7876 3.26816 11.5273 3.52851L7.9987 7.05711L4.4701 3.52851C4.20975 3.26816 3.78764 3.26816 3.52729 3.52851C3.26694 3.78886 3.26694 4.21097 3.52729 4.47132L7.05589 7.99992L3.52729 11.5285C3.26694 11.7889 3.26694 12.211 3.52729 12.4713C3.78764 12.7317 4.20975 12.7317 4.4701 12.4713L7.9987 8.94273L11.5273 12.4713C11.7876 12.7317 12.2098 12.7317 12.4701 12.4713C12.7305 12.211 12.7305 11.7889 12.4701 11.5285L8.94151 7.99992L12.4701 4.47132Z",
    fill: "#FB7B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.3e215b48ae28084befd87c3b548725aa.svg";
export { ForwardRef as ReactComponent };